import PropTypes from 'prop-types';
import React from 'react';
import PureComponent from 'ROOT/src/components/pure';
// import Breadcrumb from './breadcrumb';

import sAction from 'sAction';

export default class Header extends PureComponent {
    constructor() {
        super();
        this.searchInput = React.createRef();

        this.state = {
            showUserMoreOptions: false,
            actualModule: null,
            userCompany: sAction.dataGet('conf/user/company'),
        };
    }

    componentDidUpdate() {
        const actualModule = sAction.dataGet('view/modul');
        if (this.state.actualModule != actualModule) {
            this.setState({actualModule: actualModule});
        }
    }

    handleSearch(val = undefined) {
        if (val !== undefined) {
            this.searchInput.current.value = val;
            return;
        }

        val = this.searchInput.current.value;
        sAction.href('#globalSearch/' + encodeURI(val));
        sAction.route();
    }

    searchKeyUp(ev) {
        if (ev.keyCode == 13) {
            this.handleSearch();
        }
    }

    getLink(child) {
        const onClick = child.action ? sAction[child.action] : undefined;
        let link = <a key={child.label} href={child.href || undefined}
            onClick={onClick}
            className="mdi mdi-chevron-right">{sAction.translate(child.label)}
        </a>;
        if (child.action2) {
            const onClick = child.action2 ? sAction[child.action2] : undefined;
            const link2 = <a key={child.label2} href={child.href2 || undefined}
                className="mdi-subitem"
                onClick={onClick}>{sAction.translate(child.label2)}</a>;
            link = <React.Fragment key={child.label + child.label2}>{link} {link2}</React.Fragment>;
        }
        return link;
    }

    getMenu() {
        const ret = [];
        if (!sAction.menu) {
            return ret;
        }
        sAction.menu.forEach((item) => {
            const children = [];
            let childrenT = [];
            if (item.children) {
                item.children.forEach((child) => {
                    const link = this.getLink(child);
                    children.push(link);
                });
                childrenT = <div key={item.label} className="dropdown-content">{children}</div>;
            }

            const hrefArr = item.href.split('/');
            // ret.push(
            //     <li key={item.label}
            //         className={'dropdown' + (this.state.actualModule == hrefArr[hrefArr.length - 1] ? ' actual' : '')}>
            //         <a href={item.href} className={children.length ? 'dropdown' : ''}>{sAction.translate(item.label)}</a>
            //         {childrenT}
            //     </li>,
            // );

            const urlSplit = window.location.href.split('/');
            let moduleFromUrl = urlSplit[urlSplit.length - 1];
            if (urlSplit.includes('#detail')) {
                moduleFromUrl = urlSplit[urlSplit.length - 2];
            }
            ret.push(
                <div key={item.label}
                    className={'navBarMenuItem ' +
                        (this.state.actualModule == hrefArr[hrefArr.length - 1] ||
                            item.module == moduleFromUrl ||
                            item.href == window.location.hash ? ' active' : '')
                    }>
                    <a href={item.href}>{sAction.translate(item.label)}</a>
                </div>,
            );
        });
        return ret;
    }

    getReponsiveMenu() {
        const ret = [];
        if (!sAction.menu) {
            return ret;
        }
        sAction.menu.forEach((item) => {
            const children = [];
            let childrenT = [];
            if (item.children) {
                item.children.forEach((child) => {
                    const link = this.getLink(child);
                    children.push(link);
                });
                childrenT = <div key={item.label}>{children}</div>;
            }

            ret.push(
                <div key={item.label}><a href={item.href}>{sAction.translate(item.label)}</a>{childrenT}<br /></div>,
            );
        });

        return <li className="dropdown dropdownWrapper">
            <a className="dropdown dropdownMenuText">MENU</a>
            <div className="dropdown-content">{ret}</div>
        </li>;
    }

    sendEmail = () => {
        const emailData = {
            to_addrs: 'ifsupport@aon.com',
            account: 'portal_user',
            send_individually: true,
            disable_recipient_change: true,
            contact_form: true,
            loaded: true,
        };

        sAction.openEmailPopup(emailData);
    };

    handleToggleUserMoreOptions = (onlyHide = false) => {
        this.setState({
            showUserMoreOptions: onlyHide ? false : !this.state.showUserMoreOptions,
        });
    };

    alertMessageClick() {
        const alertMessage = sAction.dataGet('conf/alertMessage');
        if (sAction[alertMessage.get('buttonAction')] != undefined) {
            if (alertMessage.get('buttonAction') == 'logoutAs') {
                localStorage.setItem('portalLoginAs', false);
                sAction.logOut();
            } else {
                sAction[alertMessage.get('buttonAction')]();
            }
        } else {
            console.log(
                'Action ' + alertMessage.get('buttonAction') + ' is not defined (ER421F)',
            );
        }
    }

    render() {
        const user = this.props.user;
        const recordName = this.props.recordName;
        const isSuperUser = user.is_superUser !== null && !!user.is_superUser;
        const breadcrumbData = sAction.breadcrumb(recordName);
        const isAdminUser = sAction.dataGet('conf/user/is_admin') == '1';
        const alertMessage = sAction.dataGet('conf/alertMessage');

        return (
            <>
                <div className="menu-wrapper">
                    <div className="topHeaderWrapper">
                        {alertMessage.get('show') == true && (
                            <div className="headerAlertPanel">
                                <p>{alertMessage.get('message')}
                                    {alertMessage.get('buttonAction') != undefined && (
                                        <a onClick={() => this.alertMessageClick()}>
                                            {alertMessage.get('buttonLabel')}
                                        </a>
                                    )}</p>
                            </div>
                        )}
                        <div className="topHader">
                            <div className="topHaderContent">
                                <div className="leftSection">
                                    <div className="contactUs" onClick={this.sendEmail}>
                                        <i className="iconfa-email"></i>
                                        <div className="contactText">
                                            <p>{sAction.translate('LBL_CONTACT_US')}</p>
                                        </div>
                                    </div>
                                </div>
                                <p className="centerText">{this.state.userCompany ? this.state.userCompany : ''}</p>
                                <div className="userInfoBox" onClick={() => {
                                    this.handleToggleUserMoreOptions();
                                }}>
                                    <div className="portalUser">
                                        <i className="iconfa-user"></i>
                                        <div className="userName">
                                            <p>{user.name}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'moreOptionsWrapper' + (this.state.showUserMoreOptions ? ' show' : '')}>
                        <div className="moreOptions">
                            <a href={'#detail/acm_portal_users/' + user.id} onClick={() => {
                                this.handleToggleUserMoreOptions(true);
                            }} >
                                {/* <span className="iconfas-settings icon"></span> */}
                                {sAction.translate('LBL_PORTAL_USER_SETTINGS')}
                            </a>
                            { isAdminUser &&
                                <a href={'#list/acm_portal_users'} onClick={() => {
                                    this.handleToggleUserMoreOptions(true);
                                }} >
                                    {/* <span className="iconfas-settings icon"></span> */}
                                    {sAction.translate('LBL_PORTAL_USERS')}
                                </a>
                            }
                            <a onClick={() => {
                                sAction.logOut(); this.handleToggleUserMoreOptions(true);
                            }}>
                                {/* <span className="icon-portalLogout icon"></span> */}
                                {sAction.translate('LBL_LOGOUT')}
                            </a>
                        </div>
                        <div className="blur_filter" onClick={() => {
                            this.handleToggleUserMoreOptions(true);
                        }}></div>
                    </div>

                    <div className="navBar">
                        <div className="navBarContainer">
                            <div className="navBarLogo">
                                <a href="#home"><img src={sAction.param.companyLogo} alt="logo"/></a>
                            </div>
                            <div className="navBarMenu">
                                {/* <div className="navBarMenuItem active">
                                    <a href="#home">Hone</a>
                                </div>
                                <div className="navBarMenuItem">
                                    <a href="#home">Documents & Software</a>
                                </div>
                                <div className="navBarMenuItem">
                                    <a href="#home">Communication</a>
                                </div>
                                <div className="navBarMenuItem">
                                    <a href="#home">List of license</a>
                                </div>
                                <div className="navBarMenuItem">
                                    <a href="#home">Latest Documents & Software</a>
                                </div>
                                <div className="navBarMenuItem">
                                    <a href="#home">Contact us</a>
                                </div> */}

                                {this.getMenu()}

                                <div className="navBarMenuItem searchBox">
                                    <div className="search navBarSearchBox">
                                        <input
                                            className="searchInput"
                                            type="text"
                                            placeholder={sAction.translate('LBL_GLOBAL_SEARCH_PLACEHOLDER')}
                                            ref={this.searchInput}
                                            onKeyUp={(ev) => this.searchKeyUp(ev)}
                                        />
                                        <div className="icon-closeIconLight clearButton" onClick={() => this.handleSearch('')}></div>
                                        <i className="searchIcon icon-search"
                                            onClick={() => this.handleSearch()}
                                        >
                                        </i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="menu-container-placeholder"></div>

                {/* <Breadcrumb data={breadcrumbData}/> */}
            </>
        );
    }
}

Header.propTypes = {
    recordName: PropTypes.any,
    user: PropTypes.shape({
        id: PropTypes.any,
        is_superUser: PropTypes.any,
        name: PropTypes.any,
    }),
};


